import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setPageMeta } from '../utils/seo';
import { HIRING_GUIDES } from '../data/hiringGuides';
import { ArrowRight, BookOpen } from '@phosphor-icons/react';

export default function HiringGuides() {
  useEffect(() => {
    window.scrollTo(0, 0);
    setPageMeta({
      title: 'Contractor Hiring Guides — Choose, Vet & Pay Pros Safely | ConstructHelp',
      description: 'Free guides on choosing a contractor, spotting scams, checking licenses, comparing quotes, and signing safe contracts — written for homeowners in 2026.',
      url: `${window.location.origin}/hiring-guides`,
    });
  }, []);

  return (
    <div className="min-h-screen bg-[#E8E9EB] dark:bg-[#121212]" data-testid="hiring-guides-page">
      <div className="bg-neutral-900 border-b-4 border-[#D95800]">
        <div className="max-w-5xl mx-auto px-4 py-12">
          <div className="w-14 h-14 bg-[#D95800] border-2 border-white flex items-center justify-center mb-5">
            <BookOpen size={30} weight="bold" className="text-white" />
          </div>
          <h1 className="text-4xl sm:text-5xl font-black text-white uppercase leading-tight mb-3">Contractor Hiring Guides</h1>
          <p className="text-neutral-300 max-w-2xl">Everything you need to hire with confidence — from vetting licenses to signing a contract that actually protects you.</p>
        </div>
      </div>
      <div className="max-w-5xl mx-auto px-4 py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {HIRING_GUIDES.map((g) => (
            <Link key={g.slug} to={`/hiring-guides/${g.slug}`}
              className="bg-white dark:bg-neutral-800 border-2 border-neutral-900 dark:border-neutral-700 p-6 shadow-[3px_3px_0px_#000] hover:-translate-y-0.5 transition-transform"
              data-testid={`hiring-guide-card-${g.slug}`}>
              <h2 className="font-black uppercase text-neutral-900 dark:text-white mb-2">{g.h1}</h2>
              <p className="text-sm text-neutral-600 dark:text-neutral-400 mb-3">{g.description}</p>
              <span className="text-sm font-bold text-[#D95800] flex items-center gap-1">Read the guide <ArrowRight size={14} weight="bold" /></span>
            </Link>
          ))}
        </div>
        <div className="mt-10 flex flex-wrap gap-4 justify-center">
          <Link to="/guides" className="font-bold text-[#D95800] underline" data-testid="hiring-to-cost-guides">2026 cost guides →</Link>
          <Link to="/hire" className="font-bold text-[#D95800] underline" data-testid="hiring-to-hire">Hire a pro by trade →</Link>
        </div>
      </div>
    </div>
  );
}
